import config from "aldoo-ra/Config"
import React from "react"
import HeaderMenuDesktop from "./HeaderMenuDesktop"
import HeaderMenuMobile from "./HeaderMenuMobile"

export default function Navbar() {
  return (
    <div>
      <div
        className="relative w-full h-header_height top-0 left-0 flex flex-col items-center justify-cente bg-paper"
        style={{ zIndex: 200 }}
      >
        <div
          className="fixed w-full h-header_height top-0 left-0 flex flex-col items-center justify-center"
          style={{ zIndex: 200 }}
        >
          <div className="hidden lg:block w-full">
            <HeaderMenuDesktop />
          </div>

          <div className="lg:hidden w-full">
            <HeaderMenuMobile />
          </div>
        </div>
      </div>
    </div>
  )
}
